// Centralized function to check and update the checkout button's state
updateCheckoutButtonState = function() {
    const checkoutButton = document.getElementById('checkout');
    const dateInput = document.getElementById('date');
    const selectedDate = dateInput ? dateInput.value : '';
    
    // Calculate cart total weight
    const cartWeightElement = document.getElementById('cart_total_weight');
    const cartWeightValue = parseFloat(cartWeightElement.textContent.replace('kg', '').trim());

    // If sample customer, only check if the delivery date is selected
    if(isSampleCustomer === true) {
        if (!selectedDate) {
            checkoutButton.disabled = true;
        } else {
            checkoutButton.disabled = false;
        }
    } else {
        if (!selectedDate || cartWeightValue < 24) {
            checkoutButton.disabled = true;
        } else {
            checkoutButton.disabled = false;
        }
    }

    // Check if the delivery date is selected, if not, show error message
    const dateError = document.getElementById('date-error');

    if(!selectedDate) {
        if(!dateError) {
            const newDiv = document.createElement("div");
            newDiv.setAttribute("id", "date-error");
            newDiv.textContent = "Bitte wählen Sie ein Liefertermin";

            dateInput.parentNode.insertBefore(newDiv, dateInput.nextSibling);
        }
    } else if (dateError) {
        dateError.remove();
    }
}